<template>
    <svg :width="width" :height="height" :viewBox="`0 0 ${width} ${height}`" fill="none" xmlns="http://www.w3.org/2000/svg" :class="classes">
        <path d="M24.8 26H28V28.6667H20V20.6667H22.6667V24.3067C25.1067 22.3467 26.6667 19.36 26.6667 16C26.6667 10.5733 22.5867 6.08 17.3334 5.42667V2.73334C24.0667 3.4 29.3334 9.08 29.3334 16C29.3334 19.9867 27.5734 23.56 24.8 26ZM5.33335 16C5.33335 12.64 6.89335 9.64 9.33335 7.69334V11.3333H12V3.33334H4.00002V6H7.20002C4.42669 8.44 2.66669 12.0133 2.66669 16C2.66669 22.92 7.93335 28.6 14.6667 29.2667V26.5733C9.41335 25.92 5.33335 21.4267 5.33335 16Z" fill="#071689"/>
        <path d="M10.3333 14.5867L14.1066 18.36L17.88 14.5867L21.6533 10.8133L23.5333 12.6933L14.1066 22.12L8.45331 16.4667L10.3333 14.5867Z" fill="#32DAC3"/>
    </svg>
</template>

<script>
export default {
    name: "ReorderIcon",

    props: {
        width: {
            type: Number,
            default: 42
        },

        height: {
            type: Number,
            default: 42
        },

        classes: {
            type: String
        }
    }
}
</script>